export default {
  common: {
    select_lang: "Ngôn ngữ",
  },
  login: {
    title: "Đăng nhập",
    and: "và",
    selectBranch: "Chọn merchant",
    forgotpassword: "Quên mật khẩu?",
    register: "Đăng ký ngay",
    loginwith: "Hoặc đăng nhập với",
    loginnow: "Đăng nhập ngay",
    hasAccount: "Bạn đã có tài khoản?",
    notAccount: "Bạn chưa có tài khoản?",
    setupAccount: "Thiết lập tài khoản",
    countDown: "Vui lòng chờ trong ",
    setupSuccessTitle: "Thiết lập tài khoản thành công!",
    activeSuccessTitle: "Kích hoạt tài khoản thành công!",
    registerSuccessTitle: "Đăng ký thành công",
    registerSuccessContent:
      "Cảm ơn bạn đã đăng ký dịch vụ cổng thanh toán của JetPay. Vui lòng bổ sung hồ sơ đơn vị để bắt đầu sử dụng",
    IdentifySuccessTitle: "Thông tin tài khoản của bạn đã được đăng ký thành công",
    IdentifySuccessTitleSecond:
      "JETPAY sẽ kiểm tra hồ sơ để phản hồi trong 2 giờ làm việc và gửi kết quả qua email bạn đã cung cấp",
    EditIdentifySuccessTitle: "Cập nhật hồ sơ đăng ký thành công",
    IdentifyAcceptedTitle: "Hồ sơ định danh của bạn đã được phê duyệt!",
    buttons: {
      login: "Đăng nhập",
      backtoLogin: "Quay lại màn hình đăng nhập",
      register: "Đăng ký",
      forgotpassword: "Quên mật khẩu",
      usePhoneNumber: "Sử dụng số điện thoại",
      useEmail: "Sử dụng email",
      returnLogin: "Quay lại đăng nhập",
      next: "Tiếp theo",
      savePassword: "Lưu mật khẩu",
      otherWay: "Thử cách khác",
      accuracy: "Xác thực",
      active: "Kích hoạt tài khoản",
      resendOTP: "Gửi lại mã xác thực",
      otp: "Mã xác thực",
    },
    error: {
      incorrect: "Thông tin đăng nhập không đúng. Vui lòng kiểm tra lại.",
      passwordNotMatch: "Mật khẩu mới và xác nhận mật khẩu không trùng nhau",
      userNotFound: "Bạn không có quyền truy cập trang này",
      userIsLockout: "Tài khoản đang bị khóa. Vui lòng liên hệ quản lý",
    },
    input_text: {
      email: "Địa chỉ gmail",
      password: "Mật khẩu",
      lastName: "Họ và tên đệm",
      firstName: "Tên",
      userName: "Email hoặc số điện thoại",
    },
    messages: {
      none_account: "Tạo tài khoản mới",
      register: "Đăng ký",
      notempty: "Thông tin đăng nhập không được để trống. Vui lòng kiểm tra lại.",
    },
    labels: {
      confirmPass: "Xác nhận mật khẩu mới",
      confirmPassword: "Xác nhận mật khẩu",
      password: "Mật khẩu",
    },
    contents: {
      passwordContent: "Nhập mật khẩu có tối thiểu 8 ký tự bao gồm số, chữ hoa, chữ thường.",
      twofactorTitle: "Xác thực 2 yếu tố",
      twofactorContent: "Thử cách nhận mã xác thực khác",
      active: "Kích hoạt tài khoản",
      register: "Tạo tài khoản Jetpay",
      serviceType: "Chọn dịch vụ",
    },
  },
  register: {
    title: "Đăng ký đơn vị chấp nhận thanh toán",
    titleInfo: "Thông tin đơn vị chấp nhận thanh toán",
    labels: {
      contact: "Người liên hệ",
      unitinfo: "Thông tin đơn vị",
    },
    input_text: {
      email: "Địa chỉ gmail",
      password: "Mật khẩu",
      lastName: "Họ và tên đệm",
      firstName: "Tên",
      taxCode: "Mã số thuế/Mã ngân sách",
    },
    buttons: {
      continue: "Tiếp tục",
      cancel: "Hủy",
    },
  },
};
